import React from 'react'
import Socials from '../socials/socials'
import './contact.css'

const Contact = () => {
  return (
    <div className="contact-hero">
        <div className="contact-left">Feel free to contact me</div>
        <div className="contact-center"><a href="mailto:errorassassin101@gmail.com">errorassassin101@gmail.com</a></div>
        <div className="contact-right"><Socials /></div>
    </div>
  )
}

export default Contact